export default __webpack_public_path__ + "static/media/T10.3da2e2fd.JPG";